// extracted by mini-css-extract-plugin
export default {"description":"Autofill_description__Zh6GO","options":"Autofill_options__Lilxt","option":"Autofill_option__F2zJ-","selected":"Autofill_selected__s9xNp"};